import React from 'react';

const Home = () => {
  return <h2>This is an example of deploying a static site created with <a href="https://react.dev/" target="_blank" rel="noopener">React</a> on github pages.</h2>;
};

export default Home;